import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function DepositListMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.salon.deposit.list);
  };

  return (
    <MainMenuItem
      itemTitleString="加盟店の\n集金状況"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default DepositListMenuItem;
